module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/screenprint-1b9c6f95b1e75f75f1e28267511bb702.svg";